import { stylesheet } from 'astroturf';


const Classes = stylesheet`
  .btn-cancel {
    cursor: pointer;
    color: var(--ph-gray-400);
  }

  .btn-save-and-apply:active {
    color: var(--ph-orange-500);
    background-color: var(--white);
  }

  .btn-save-and-apply[class*="disabled"] {
    color: var(--white);
    background-color: var(--ph-gray-300);
  }
`;

export default {
  Classes,
};
